import React from 'react';
import styled from 'styled-components';
import BottomFooterItems from './bottom-footer-items';

const BottomFooter = ({ className }) => (
  <footer className={className}>
    <BottomFooterItems />
  </footer>
);

export default styled(BottomFooter)`
  &:not(:empty) {
    background-color: #343434;
    padding: 1rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    a {
      font-weight: 300;
      font-size: 80%;
      color: white;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
